{
  "tabs": {
    "chat": "Sheekeysi",
    "reminders": "Xusuusin",
    "calendar": "Kalandar",
    "settings": "Dejinta"
  },
  "common": {
    "cancel": "Jooji",
    "save": "Kaydi",
    "confirm": "Xaqiiji",
    "delete": "Tirtir",
    "back": "Dib",
    "close": "Xir",
    "edit": "Tafatir",
    "search": "Raadi",
    "all": "Dhammaan",
    "loading": "Soo raraya...",
    "error": "Waxbaa qaldamay",
    "notFound": "Lama helin",
    "tryAgain": "Fadlan isku day mar kale",
    "retry": "Dib isku day",
    "undo": "Ka noqo",
    "pullToRefresh": "Jiid si aad u cusboonaysiiso",
    "justNow": "Hadda"
  },
  "auth": {
    "welcome": "Ku soo dhawoow FishMemory",
    "tagline": "Kaaliyahaaga xusuusinta WhatsApp, hadda jeebkaaga ku jira.",
    "subtitle": "Kaaliyahaaga xusuusinta WhatsApp, hadda jeebkaaga ku jira.",
    "phoneLabel": "Lambarkaaga WhatsApp",
    "phoneHint": "Waxaan kuu soo diri doonaa kood xaqiijin ah WhatsApp",
    "invalidPhone": "Fadlan geli lambar telefoon oo sax ah",
    "continue": "Sii wad",
    "enterPhone": "Geli lambarkaaga WhatsApp",
    "phonePlaceholder": "Lambarka telefoonka",
    "sendCode": "Dir Kood",
    "verifyTitle": "Xaqiiji lambarkaaga",
    "otpSentTo": "Kood 6-lambar ah ayaa loo diray {{phone}} WhatsApp",
    "enterFullCode": "Fadlan geli dhammaan 6-lambar",
    "invalidOtp": "Kood aan sax ahayn. Fadlan isku day mar kale.",
    "otpFailed": "Koodka lama diri karin. Isku day mar kale.",
    "otpResent": "Koodka waa la diray mar kale",
    "resendIn": "Dib u dir {{seconds}}s",
    "resendCode": "Dib u dir koodka",
    "enterOtp": "Geli koodka laguu soo diray WhatsApp",
    "verify": "Xaqiiji",
    "resend": "Dib u dir koodka",
    "wrongNumber": "Lambar khaldan?",
    "backToPhone": "Dib ugu noqo telefoonka",
    "editPhone": "Tafatir lambarka telefoonka",
    "error": "Khalad",
    "setupTitle": "Aan dejino waxyaabaha",
    "setupSubtitle": "Mar walba waad beddeli kartaa tan Dejinta",
    "namePlaceholder": "Magacaaga",
    "letsGo": "Dhammee dejinta",
    "skipForNow": "Haatan dhaaf"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Qor fariin...",
    "inputPlaceholder": "Qor fariin...",
    "typing": "FishMemory ayaa qoraya...",
    "online": "Khadka",
    "connecting": "Isku xiraya...",
    "reconnecting": "Dib u xiraya...",
    "offline": "Khadka ma jiro",
    "empty": "Bilow sheekeysi",
    "emptyHint": "Abuur xusuusin, eeg jadwalkaaga, ama weydii caawimaad.",
    "emptyAction": "Dir tusaale xusuusin",
    "actions": "Ficilada sheekeysiga",
    "keep": "Hay fariimaha",
    "clearTitle": "Nadiifi sheekeysiga",
    "clearConfirm": "Ma tirtiri kartaa dhammaan fariimaha qalabkan? Tani lama celin karo.",
    "clear": "Nadiifi sheekeysiga",
    "optionSelected": "La doortay: {{label}}",
    "sendingSelection": "Diraya...",
    "connectionLost": "Dib u xiraya..."
  },
  "reminders": {
    "title": "Xusuusinadayda",
    "active": "Firfircoon",
    "today": "Maanta",
    "thisWeek": "Toddobaadkan",
    "history": "Taariikh",
    "items": "shay",
    "emptyTitle": "Xusuusin ma jirto",
    "emptySubtitle": "Mid ka samee sheekeysiga si uu halkan u soo baxo.",
    "emptyAction": "Fur sheekeysiga",
    "filterActive": "Firfircoon",
    "filterToday": "Maanta",
    "filterWeek": "Toddobaadkan",
    "filterHistory": "Taariikh",
    "emptyState": "Xusuusin ma jirto. Bilaaw sheekeysiga!",
    "swipeDone": "La qabtay",
    "swipeSnooze": "Dib u dhig",
    "swipeDelete": "Tirtir",
    "search": "Raadi xusuusin...",
    "upcoming": "Kusoo socda",
    "completed": "La qabtay",
    "overdue": "Ka dib waqti",
    "tomorrow": "Berri",
    "synced": "Isku xiran {{value}}",
    "swipeHint": "Jiid xusuusin si aad u aragto ficilada",
    "noResults": "Xusuusin la mid ah ma jirto",
    "noResultsHint": "Isku day eray kale ama nadiifi raadinta",
    "deleteAllFailed": "Ma tirtiri karo dhammaan xusuusinada"
  },
  "calendar": {
    "title": "Kalandar",
    "today": "Maanta",
    "tomorrow": "Berri",
    "completed": "la qabtay",
    "noEvents": "Waxba ma qorshaysna",
    "noEventsSubtitle": "Dooro taariikh si aad u aragto xusuusinada iyo dhacdooyinka kalandarka.",
    "googleEvent": "Google Kalandar",
    "legendActive": "Firfircoon",
    "legendRecurring": "Ku soo noqnoqda",
    "legendDone": "La qabtay",
    "legendGoogle": "Google",
    "previousMonth": "Bishii hore",
    "nextMonth": "Bisha xigta",
    "previousYear": "Sannadkii hore",
    "nextYear": "Sannadka xiga",
    "goToToday": "Tag maanta",
    "all": "Dhammaan",
    "active": "Firfircoon",
    "done": "La qabtay",
    "paused": "Joojiyey"
  },
  "settings": {
    "title": "Dejinta",
    "profile": "Faahfaahinta",
    "name": "Magaca Muuqaalka",
    "enterName": "Geli magacaaga",
    "language": "Luqadda",
    "uiLanguage": "Luqadda app-ka",
    "uiLanguageHelp": "Waxay beddeshaa UI-ga app-ka, calaamadaha kalandarka, iyo jihada qaabka qalabkan oo kaliya.",
    "serverLanguage": "Luqadda sheekeysiga",
    "serverLanguageHelp": "Waxay beddeshaa luqadda ay adeegsadaan jawaabaha server-ka iyo fariimaha xusuusinta ee koontadaada.",
    "timezone": "Aagga Waqtiga",
    "currentTimezone": "Aagga waqtiga hadda",
    "timezoneHelp": "Dhammaan waqtiga xusuusinada waxaa lagu soo bandhigayaa aaggani.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Kaydi aagga waqtiga",
    "timezoneSaved": "Aagga waqtiga waa la cusbooneysiiyey",
    "detect": "Ogow",
    "detectFailed": "Lama ogaan karo aagga waqtiga",
    "autoDetect": "Si toos ah uga ogaaw GPS",
    "notifications": "Ogeysiisyada",
    "notificationsHelp": "Xusuusinada daba-galka ah waxay maamulaan digniinaha soo noqnoqda kadib marka xusuusin la bixiyo. Ogolaanshaha ogeysiiska qalabka waxaa weli lagu maamulaa dejimaha telefoonkaaga.",
    "pushEnabled": "Ogeysiisyada Riix",
    "autoDoneOnFire": "Si toos ah u calaamadi marka la kiciyo",
    "autoDoneOnFireDesc": "Marka la damiyo, xusuusinadu waxay sii ahaanayaan firfircoon ilaa aad calaamadiso in la qabtay.",
    "googleCalendar": "Google Kalandar",
    "google": "Google Kalandar",
    "googleConnected": "Ku xiran",
    "googleDisconnected": "Ma xiran",
    "googleConnectedHelp": "Xusuusinada cusub si toos ah ayaa loogu wadaagi karaa kalandarkaaga.",
    "googleDisconnectedHelp": "Ku xidh Google Kalandar si xusuusinada iyo dhacdooyinka loo waafajiyo.",
    "googleConnectFailed": "Ku xidh Google Kalandar waa la guuldareystay",
    "connected": "Ku xiran",
    "disconnected": "Ma xiran",
    "connect": "Ku xidh",
    "disconnect": "Ka go'",
    "autoSync": "Si toos ah u wadaag xusuusinada cusub",
    "autosync": "Si toos ah u wadaag xusuusinada cusub",
    "subscription": "Soo iibsasho",
    "trialUsed": "Tijaabo: {{used}}/{{total}} la isticmaalay",
    "trialStatus": "Tijaabo diyaar ah",
    "activeStatus": "Soo iibsasho firfircoon",
    "expiredStatus": "Soo iibsasho dhacday",
    "unsubscribedStatus": "Ma isdiiwaangelin",
    "about": "Ku saabsan",
    "version": "Nooca",
    "logout": "Ka bax",
    "logoutTitle": "Ka bax",
    "logoutConfirm": "Ma hubtaa inaad ka baxayso?",
    "noName": "Magac lama dejin",
    "serverConnection": "Xiriirka server-ka",
    "serverUrl": "URL server",
    "serverEdit": "Tafatir",
    "saveReconnect": "Kaydi oo dib u xir",
    "resetDefault": "Dib u celi asalka",
    "invalidServerUrlTitle": "URL server aan sax ahayn",
    "invalidServerUrlMessage": "Geli URL server oo sax ah http ama https, tusaale https://example.com",
    "uiLanguageChangeFailed": "Luqadda app-ka lama beddeli karo. Fadlan isku day mar kale.",
    "serverLanguageChangeFailed": "Luqadda sheekeysiga lama beddeli karo. Fadlan isku day mar kale.",
    "timezoneChangeFailed": "Aagga waqtiga lama beddeli karo. Fadlan isku day mar kale.",
    "autoSyncChangeFailed": "Wadaagista tooska ah lama cusbooneysiin karo. Fadlan isku day mar kale.",
    "nameChangeFailed": "Magaca muuqaalka lama cusbooneysiin karo. Fadlan isku day mar kale.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Faahfaahinta xusuusinta",
    "editTime": "Tafatir Waqtiga",
    "rename": "Magac beddel",
    "snooze": "Dib u dhig",
    "snooze15": "Dib u dhig 15 daqiiqo",
    "pause": "Jooji",
    "pauseReminder": "Jooji xusuusinta",
    "resume": "Sii wad",
    "resumeReminder": "Sii wad xusuusinta",
    "skip": "Ka bood xiga",
    "skipOccurrence": "Ka bood dhacdadan",
    "syncGoogle": "La wadaag Google",
    "delete": "Tirtir",
    "deleteTitle": "Tirtir Xusuusin",
    "deleteConfirm": "Xusuusintan si joogto ah ayaa loo tirtiri doonaa.",
    "deleteRecurringTitle": "Tirtir Xusuusin Soo Noqnoqda",
    "deleteRecurringMessage": "Ma rabtaa inaad ka booddo dhacdadan ama tirtir taxanaha oo dhan?",
    "deleteThisOccurrence": "Ka bood dhacdadan",
    "deleteEntireSeries": "Tirtir taxanaha oo dhan",
    "done": "La qabtay",
    "markDone": "Calaamadi sida la qabtay",
    "undo": "Soo celi",
    "undoPrompt": "Ma u baahan tahay in mar kale firfircoon noqoto? Soo celi hadda.",
    "recurring": "Soo noqnoqda",
    "nextRun": "Mar xiga",
    "oneTime": "Hal mar",
    "pending": "Sugaya",
    "sent": "La diray",
    "paused": "La joojiyey",
    "active": "Firfircoon",
    "snoozed": "La dib dhigay",
    "localTime": "Waqtiga maxalliga ah ayaa la muujiyey",
    "recurrence": "Soo noqnoqoshada",
    "created": "La abuuray",
    "tags": "Tags",
    "fireCount": "Jeer la kiciyey",
    "actions": "Ficilada",
    "none": "Midna ma jiro",
    "snoozeFailed": "Dib u dhigista xusuusinta waa la guuldareystay",
    "pauseFailed": "Joojinta xusuusinta waa la guuldareystay",
    "resumeFailed": "Sii wadida xusuusinta waa la guuldareystay",
    "skipFailed": "Ka boodista xusuusinta waa la guuldareystay",
    "doneFailed": "Calaamadinta xusuusinta sida la qabtay waa la guuldareystay",
    "undoFailed": "Soo celinta xaaladda xusuusinta waa la guuldareystay",
    "deleteFailed": "Tirtirida xusuusinta waa la guuldareystay",
    "rescheduleTitle": "Dib u jadwalayn?",
    "rescheduleMsg": "Xusuusintan waa mid ka dib waqti. Ma rabtaa inaad dib u jadwalayso?",
    "reschedule15": "15 daqiiqo kadib",
    "reschedule60": "1 saac kadib",
    "keepOverdue": "Sii sida ay tahay"
  },
  "onboarding": {
    "slide1Title": "Ku soo dhawoow FishMemory",
    "slide1Sub": "Kaaliyahaaga xusuusinta gaarka ah — oo ay awood siiso WhatsApp kuna dhisan jeebkaaga.",
    "slide2Title": "Kaliya Sheekeysi Dabiici ah",
    "slide2Sub": "Qor xusuusin sida aad u fikirto: \"I xusuusi inaan waco hooyo berri 3pm\" — annaga ayaa inta kale qabaneyna.",
    "slide3Title": "Waligaa Ha Seegin Wax",
    "slide3Sub": "Hel ogeysiisyo waqtigooda ah, abaabul calaamado, oo la soco wax walba oo muhiim ah.",
    "getStarted": "Bilow",
    "next": "Xiga",
    "firstReminderTitle": "Samee xusuusintaada ugu horreysa!",
    "firstReminderHint": "Isku day inaad qorto wax sidan oo kale ah:",
    "firstReminderExample": "I xusuusi inaan biyo cabo berri 9 AM",
    "gotIt": "Waan fahmay!",
    "notifRationaleTitle": "Joog wakhtiga",
    "notifRationaleBody": "FishMemory waxay u baahan tahay ogeysiisyo si ay kuugu xusuusiso waqtiga. Waxaad heli doontaa digniinno kaliya xusuusinada aad abuurto.",
    "notifRationaleAllow": "Ogeysiisyada Daar",
    "notifRationaleLater": "Mar dambe laga yaabo",
    "swipeHint": "Jiid midig si ficil degdeg ah →",
    "calendarDragHint": "Jiid si aad u ballaariso ↕"
  }
}
